import SiteHeaderDesktop from './SiteHeaderDesktop';
import SiteHeaderContainer from '../SiteHeader.container';
import SiteHeaderDesktopNetworkbar from '../SiteHeaderDesktop.networkbar';
import { withFeatureBranch } from '../../redux/flags';
export default withFeatureBranch({ networkbar: SiteHeaderDesktopNetworkbar })(SiteHeaderContainer(SiteHeaderDesktop));
//# sourceMappingURL=index.js.map